<ng-container *ngIf="country === 'USA'">
  <p>1. {{ labels?.stellar?.excludesWalmart }}</p>
</ng-container>
